import axios from "axios";
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import "./Style/globalValidasiEror.scss";
import Url from "../global";

const FormAddRiwayatKepangkatan = () => {
  const [kepangkatan, setKepangkatan] = useState("");
  const [tglSK, setTglSK] = useState("");
  const [masaKerja, setMasaKerja] = useState("");
  const [guruKaryawanDetail, setGuruKaryawanDetail] = useState("");
  const [status, setStatus] = useState("");
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);

  const [setError] = useState(null);

  const PdfViewer = ({ fileUrl }) => {
    return (
      <div>
        {fileUrl ? (
          <embed
            src={fileUrl}
            type="application/pdf"
            width="70%"
            height="600px"
          />
        ) : (
          <p>No PDF file uploaded</p>
        )}
      </div>
    );
  };

  const handleChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile && selectedFile.type === "application/pdf") {
      setFile(selectedFile);
      setFileUrl(URL.createObjectURL(selectedFile));
    } else {
      setFile(null);
      setError("File harus berupa PDF");
    }
  };

  const {
    register,
    reset,
    trigger,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const saveRiwayatKepangkatan = async (e) => {
    // e.preventDefault();
    if (file) {
      const formData = new FormData();
      formData.append("strKepangkatan", kepangkatan);
      formData.append("dateTglSK", tglSK);
      formData.append("strMasaKerja", masaKerja);
      formData.append("strGuruKaryawanDetail", guruKaryawanDetail);
      formData.append("strStatus", status);
      formData.append("pdfFile", file);

      for (let i = 0; i < file.length; i++) {
        formData.append("files", file[i]);
      }

      try {
        await axios.post(`${Url}/riwayat_kepangkatans`, formData, {
          headers: {
            "Content-type": "multipart/form-data",
          },
        });
        navigate("/riwayat-kepangkatan");
        reset();
      } catch (error) {
        if (error.response) {
          setMsg(error.response.data.msg);
        }
      }
    }
  };
  return (
    <div>
      <h1 className="title">Riwayat Kepangkatan</h1>
      <h2 className="subtitle">Add New Riwayat Kepangkatan</h2>

      <div className="card is-shadowless">
        <div className="card-content">
          <div className="content">
            <form
              className="box"
              onSubmit={handleSubmit(saveRiwayatKepangkatan)}
            >
              <p className="has-text-centered">{msg}</p>

              <div className="field">
                <label className="label">Jenis Kepangkatan</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    <select
                      className="dropdown"
                      value={kepangkatan}
                      onChange={(e) => setKepangkatan(e.target.value)}
                      required
                    >
                      <option>------Pilih------</option>
                      <option>Yayasan/Mula 1</option>
                      <option>Yayasan/Mula 2</option>
                      <option>Yayasan/Muda 1</option>
                      <option>Yayasan/Muda 2</option>
                      <option>Yayasan/Madya 1</option>
                      <option>Yayasan/Madya 2</option>
                      <option>Yayasan/Dewasa 1</option>
                      <option>Yayasan/Dewasa 2</option>
                      <option>Yayasan/Ahli 1</option>
                      <option>Yayasan/Ahli 2</option>
                      <option>Yayasan/Profesional 1</option>
                      <option>Yayasan/Profesional 2</option>
                      <option>Yayasan/Besar</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="field">
                <label className="label">Tanggal SK</label>
                <div className="control">
                  <Form.Group controlId="duedate" className="dtp">
                    <Form.Control
                      type="date"
                      name="duedate"
                      placeholder="Tanggal SK"
                      value={tglSK}
                      onChange={(e) => setTglSK(e.target.value)}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="field">
                <label className="label">Masa Kerja</label>
                <div className="control">
                  <input
                    type="text"
                    className={`input ${errors.masaKerja && "invalid"}`}
                    {...register("masaKerja", {
                      required: {
                        value: true,
                        message: "Masa Kerja Wajib Di isi!",
                      },
                      minLength: {
                        value: 5,
                        message: "minimal 5 karakter",
                      },
                    })}
                    onKeyUp={() => {
                      trigger("masaKerja");
                    }}
                    placeholder="Masa Kerja"
                    value={masaKerja}
                    onChange={(e) => setMasaKerja(e.target.value)}
                  />
                  {errors.masaKerja && (
                    <small className="allValidasiError">
                      {errors.masaKerja.message}
                    </small>
                  )}
                </div>
              </div>

              <div className="field">
                <label className="label">Jenis Guru dan Karyawan Detail</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    <select
                      className="dropdown"
                      value={guruKaryawanDetail}
                      onChange={(e) => setGuruKaryawanDetail(e.target.value)}
                      required
                    >
                      <option>------Pilih------</option>
                      <option>GTY (Guru Tetap Yayasan)</option>
                      <option>GTTY (Guru Tidak Tetap Yayasan)</option>
                      <option>KTY (Karyawan Tetap Yayasan)</option>
                      <option>KTTY (Karyawan Tidak Tetap Yayasan)</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="field">
                <label className="label">Status Kepangkatan</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    <select
                      className="dropdown"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                      required
                      disabled="true"
                    >
                      <option>Pengajuan Sertifikat Kepangkatan</option>
                      <option>Disetujui Kabid Kepegawaian</option>
                      <option>Ditolak Kabid Kepegawaian</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="field">
                <label className="label">Sertifikat Kepangkatan</label>
                <div className="control">
                  <div className="file">
                    <label className="file-label">
                      <input
                        type="file"
                        accept="application/pdf"
                        onChange={handleChange}
                      />
                      {/* <button type="submit">Upload</button> */}
                    </label>
                  </div>
                  <br />
                  <PdfViewer fileUrl={fileUrl} />
                </div>
              </div>

              <br />
              <div className="field">
                <div className="control">
                  <button type="submit" className="button is-success">
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormAddRiwayatKepangkatan;
